import React from "react";
import { stripMentionsToText } from "utils/mention";

const isVideoUrl = (url) => /\.(mp4|mov|webm|avi|mkv)(\?|$)/i.test(url || "");

// iOS Safari/WebView는 재생 전 paused <video>의 첫 프레임을 그리지 않아 빈 칸으로 보인다.
// 미디어 프래그먼트(#t=0.1)로 0.1초 지점을 강제 seek 해 첫 프레임을 포스터처럼 노출한다.
// (BE가 영상 썸네일 URL을 내려주기 전까지의 FE 보정. CommunityCreate 미리보기와 동일한 패턴)
const posterFrameSrc = (url) => `${url}#t=0.1`;

const PlayIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
        <path d="M8 5v14l11-7z" />
    </svg>
);

const MultiIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="8" y="8" width="12" height="12" rx="2.5" fill="#fff" />
        <path
            d="M5 16V6a2 2 0 0 1 2-2h10"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

const PostMediaGrid = ({ posts, onSelect }) => {
    if (!posts || posts.length === 0) return null;

    const handleSelect = (post) => {
        if (onSelect) onSelect(post);
        else window.open(`/community/${post.id}`, "_blank");
    };

    return (
        <div className="post-media-grid">
            {posts.map((post) => {
                const media = post.media_urls || [];
                const cover = media[0];
                const isMulti = media.length > 1;
                const isVideo = cover && isVideoUrl(cover);
                const label = `${post.author_nickname || post.author_name || "게시글"} 게시글 열기`;
                return (
                    <div
                        key={post.id}
                        className="post-media-grid__cell"
                        role="button"
                        tabIndex={0}
                        aria-label={label}
                        onClick={() => handleSelect(post)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleSelect(post);
                            }
                        }}
                    >
                        {cover ? (
                            isVideo ? (
                                <video
                                    className="post-media-grid__media"
                                    src={posterFrameSrc(cover)}
                                    preload="metadata"
                                    muted
                                    playsInline
                                    data-testid="grid-media-video"
                                />
                            ) : (
                                <img
                                    className="post-media-grid__media"
                                    src={cover}
                                    alt="게시글 미디어"
                                    loading="lazy"
                                    onError={(e) => {
                                        e.currentTarget.style.visibility = "hidden";
                                    }}
                                />
                            )
                        ) : (
                            <div className="post-media-grid__text">
                                <span className="post-media-grid__text-inner">
                                    {stripMentionsToText(post.content)}
                                </span>
                            </div>
                        )}
                        {(isMulti || isVideo) && (
                            <span
                                className="post-media-grid__badge"
                                role="img"
                                aria-label={isMulti ? "여러 미디어" : "동영상"}
                            >
                                {isMulti ? <MultiIcon /> : <PlayIcon />}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default PostMediaGrid;
